import ClienteCombobox from '@/components/ui/ClienteCombobox.jsx';
import SearchableSelect from './SearchableSelect.jsx';
import { fieldClass, LabeledField } from './shared.jsx';

export default function RuleScopeFields({
  form,
  numerators,
  selectedCliente,
  clientMode,
  onChange,
  onClienteSelect,
  onClientModeChange,
  serviceOptions,
  sucursalOptions,
  origenLocalidadOptions,
  destinoLocalidadOptions,
}) {
  return (
    <div className="grid grid-cols-12 gap-3">
      <div className="col-span-12">
        <div className="mb-2 flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => {
              onClientModeChange?.('all');
              onChange('clienteId', '');
              onClienteSelect?.(null);
            }}
            className={`rounded-full px-3 py-1 text-xs font-semibold transition ${clientMode === 'all' ? 'bg-[rgba(var(--brand),0.14)] text-[rgb(var(--brand))]' : 'bg-[rgba(var(--subpanel),0.26)] text-[rgba(var(--fg),0.85)] hover:bg-[rgba(var(--subpanel),0.45)]'}`}
          >
            Todos los clientes
          </button>
          <button
            type="button"
            onClick={() => onClientModeChange?.('specific')}
            className={`rounded-full px-3 py-1 text-xs font-semibold transition ${clientMode === 'specific' ? 'bg-[rgba(var(--brand),0.14)] text-[rgb(var(--brand))]' : 'bg-[rgba(var(--subpanel),0.26)] text-[rgba(var(--fg),0.85)] hover:bg-[rgba(var(--subpanel),0.45)]'}`}
          >
            Cliente específico
          </button>
        </div>
      </div>

      <LabeledField label="Cliente" hint="Universo comercial principal." span="col-span-12 xl:col-span-8">
        {clientMode === 'all' ? (
          <div className="mt-1 flex h-9 items-center rounded-xl border border-[rgba(var(--border),0.62)] bg-[rgba(var(--subpanel),0.2)] px-3 text-sm text-[rgba(var(--muted),0.95)]">
            Todos los clientes
          </div>
        ) : (
          <div className="mt-1">
            <ClienteCombobox
              id="tariff-rule-cliente"
              name="clienteId"
              value={form.clienteId || ''}
              selectedCliente={selectedCliente}
              onChange={(event) => onChange('clienteId', event?.target?.value || '')}
              onClienteSelect={onClienteSelect}
              placeholder="Buscar cliente por nombre o código"
              disabled={clientMode !== 'specific'}
            />
          </div>
        )}
      </LabeledField>

      <LabeledField label="Subcuenta" hint="Opcional." span="col-span-12 md:col-span-6 xl:col-span-4">
        <input className={fieldClass} value={form.subcuentaId} onChange={(e) => onChange('subcuentaId', e.target.value)} placeholder="Subcuenta" />
      </LabeledField>

      <LabeledField label="Servicio" hint="Filtro operativo." span="col-span-12 md:col-span-6 xl:col-span-4">
        <SearchableSelect
          value={form.servicioCodigo || ''}
          onChange={(value) => onChange('servicioCodigo', value)}
          options={serviceOptions}
          placeholder="Todos los servicios"
          searchPlaceholder="Buscar servicio"
          emptyMessage="Sin servicios"
        />
      </LabeledField>

      <LabeledField label="Numerador" hint="Esquema comercial." span="col-span-12 md:col-span-6 xl:col-span-4">
        <SearchableSelect
          value={form.numeradorId || ''}
          onChange={(value) => onChange('numeradorId', value)}
          options={[{ value: '', label: 'Sin numerador' }, ...numerators.map((item) => ({ value: item.id, label: `${item.codigo} · ${item.nombre}` }))]}
          placeholder="Sin numerador"
          searchPlaceholder="Buscar numerador"
          emptyMessage="Sin numeradores"
        />
      </LabeledField>

      <LabeledField label="Origen sucursal" span="col-span-12 md:col-span-6 xl:col-span-4">
        <SearchableSelect
          value={form.origenSucursalId || ''}
          onChange={(value) => onChange('origenSucursalId', value)}
          options={sucursalOptions}
          placeholder="Todas las sucursales"
          searchPlaceholder="Buscar sucursal"
          emptyMessage="Sin sucursales"
        />
      </LabeledField>

      <LabeledField label="Destino sucursal" span="col-span-12 md:col-span-6 xl:col-span-4">
        <SearchableSelect
          value={form.destinoSucursalId || ''}
          onChange={(value) => onChange('destinoSucursalId', value)}
          options={sucursalOptions}
          placeholder="Todas las sucursales"
          searchPlaceholder="Buscar sucursal"
          emptyMessage="Sin sucursales"
        />
      </LabeledField>

      <LabeledField label="Origen localidad" span="col-span-12 md:col-span-6 xl:col-span-4">
        <SearchableSelect
          value={form.origenLocalidadId || ''}
          onChange={(value) => onChange('origenLocalidadId', value)}
          options={origenLocalidadOptions}
          placeholder="Todas las localidades"
          searchPlaceholder="Buscar localidad"
          emptyMessage="Sin localidades"
        />
      </LabeledField>

      <LabeledField label="Destino localidad" span="col-span-12 md:col-span-6 xl:col-span-4">
        <SearchableSelect
          value={form.destinoLocalidadId || ''}
          onChange={(value) => onChange('destinoLocalidadId', value)}
          options={destinoLocalidadOptions}
          placeholder="Todas las localidades"
          searchPlaceholder="Buscar localidad"
          emptyMessage="Sin localidades"
        />
      </LabeledField>
    </div>
  );
}
